import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../components/Loader';

const DepartmentShow = () => {
  const { id } = useParams();
  const [department, setDepartment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/departments/getByParam?id=${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => res.json())
      .then(data => {
        setDepartment(data);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load department');
        setLoading(false);
      });
  }, [id]);

  if (loading) return  <Loader />;
  if (error) return <div className="alert alert-danger">{error}</div>;
  if (!department) return <div>Department not found</div>;

  return (
    <div style={{ minHeight: '100vh', background: '#fff' }}>
      {/* Breadcrumb */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '32px 0 0 0' }}>
        <div style={{ fontSize: 15, marginBottom: 16 }}>
          <span style={{ color: '#007bff', fontWeight: 600 }}>Dashboard</span>
          <span style={{ color: '#bbb' }}> / </span>
          <span style={{ color: '#bbb' }}>Users</span>
          <span style={{ color: '#bbb' }}> / </span>
          <span style={{ color: '#bbb' }}>Staff</span>
          <span style={{ color: '#bbb' }}> / </span>
          <span style={{ color: '#bbb' }}>Departments</span>
          <span style={{ color: '#bbb' }}> / </span>
          <span style={{ background: '#2ecc71', color: '#fff', borderRadius: 4, padding: '2px 8px', fontWeight: 500 }}>{department.name}</span>
        </div>
      </div>

      {/* Main Card */}
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        {/* General Section */}
        <div style={{ background: '#fafbfc', borderRadius: 6, boxShadow: '0 2px 2px rgba(0,0,0,0.03)', padding: 32, marginBottom: 24, position: 'relative' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ fontWeight: 600, fontSize: 29, fontFamily: 'var(--font-stag)', letterSpacing: -0.435 }}>General</div>
            <button
             className="btn btn-add-user" 
              onClick={() => navigate(`/departments/${id}/edit`)}
            >
              Edit
            </button>
          </div>
          <div style={{ padding: 16, fontWeight: 400, fontSize: 16, marginBottom: 16, fontFamily: 'var(--font-montserrat)' }}>General Information</div>

          <div style={{ display: 'flex', flexDirection: 'column', marginTop: 8, justifyContent: 'center', alignItems: 'center', fontFamily: 'var(--font-montserrat)' }}>
            <div className='col-6' style={{ marginBottom: 8, display: 'flex', gap: 20, alignItems: 'center' }}>
              <span className='col-3' style={{ fontWeight: 400, color: '#36BBA5' }}>Name:</span> <span className='col-3' style={{ color: '#222' }}>{department.name}</span>
            </div>
            <div className='col-6' style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
              <span className='col-3' style={{ fontWeight: 400, color: '#36BBA5' }}>Color:</span> <span className='col-3' style={{ background: `${department.color}`, color: '#fff', borderRadius: 4, padding: '2px 8px', fontSize: 14, marginRight: 8 }}>{department.color}</span>
              {/* <span className='col-3' style={{ display: 'inline-block', width: 24, height: 18, background: department.color, border: '1px solid #eee', borderRadius: 4, verticalAlign: 'middle' }}></span> */}
            </div>
          </div>
        </div>

        {/* Users Section */}
        <div style={{ background: '#fafbfc', borderRadius: 6, boxShadow: '0 1px 2px rgba(0,0,0,0.03)', padding: 32, marginBottom: 24 }}>
          {/* <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 16 }}>Users</div> */}
          <div style={{ padding: 16, fontWeight: 400, fontSize: 16, marginBottom: 16, fontFamily: 'var(--font-montserrat)' }}>Users</div>

          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: 'transparent' }}>
              <thead>
                <tr style={{ background: '#f5f6fa' }}>
                  <th style={{ textAlign: 'left', padding: '8px 12px', fontWeight: 700, color: '#444', fontSize: 14 }}>Name</th>
                  <th style={{ textAlign: 'left', padding: '8px 12px', fontWeight: 700, color: '#444', fontSize: 14 }}>Email</th>
                  <th style={{ textAlign: 'left', padding: '8px 12px', fontWeight: 700, color: '#444', fontSize: 14 }}>Role</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(department.users) && department.users.length > 0 ? (
                  department.users.map((user) => (
                    <tr key={user.id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '8px 12px', color: '#222', fontSize: 15, fontFamily: 'var(--font-montserrat)' }}>{user.name}</td>
                      <td style={{ padding: '8px 12px', color: '#222', fontSize: 15, fontFamily: 'var(--font-montserrat)' }}>{user.email}</td>
                      <td style={{ padding: '8px 12px', color: '#222', fontSize: 15, fontFamily: 'var(--font-montserrat)' }}>{user.role}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} style={{ textAlign: 'center', color: '#bbb', fontSize: 15, padding: '16px 0' }}>No users found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Roles Section */}
        <div style={{ background: '#fafbfc', borderRadius: 6, boxShadow: '0 1px 2px rgba(0,0,0,0.03)', padding: 32, marginBottom: 24 }}>
          {/* <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 16 }}>Roles</div> */}
          <div style={{ padding: 16, fontWeight: 400, fontSize: 16, marginBottom: 16, fontFamily: 'var(--font-montserrat)' }}>Roles</div>

          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: 'transparent' }}>
              <thead>
                <tr style={{ background: '#f5f6fa' }}>
                  <th style={{ textAlign: 'left', padding: '8px 12px', fontWeight: 700, color: '#444', fontSize: 14, fontFamily: 'var(--font-montserrat)' }}>Name</th>
                </tr>
              </thead>
              <tbody>
                {department.roles && department.roles.length > 0 ? (
                  department.roles.map((role) => (
                    <tr key={role.id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '8px 12px', color: '#222', fontSize: 15 }}>{role.name}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td style={{ textAlign: 'center', color: '#bbb', fontSize: 15, padding: '16px 0' }}>No roles found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartmentShow; 